module.exports = __webpack_public_path__ + "static/media/quikview_4.ebae537b.ico";